<template>
  <div class="card mb-3">
    <div class="card-header bg-light">
      <h5 class="mb-0">Información adicional</h5>
    </div>
    <div class="card-body">
      <div class="form-group">
        <label for="observations">
          Información adicional
          <small v-if="isFormativeAction" class="text-muted d-block">
            Para las acciones formativas, se indicará aquí la modalidad de impartición: presencial / teleformación / mixta
          </small>
        </label>
        <app-textarea-ai
          :value="localResume.observations"
          @input="$emit('update:field', 'observations', $event)"
          :enable-ai="true"
          :max-chars="5000"
          :rows="3"
          :placeholder="isFormativeAction ? 'Indicar modalidad: presencial / teleformación / mixta' : 'Información adicional'"
          id="observations"
          textarea-class="form-control"
        ></app-textarea-ai>
      </div>
    </div>
  </div>
</template>

<script>
import AppTextareaAi from "@/components/forms/AppTextareaAi.vue";

export default {
  name: "AdditionalInfoSection",
  components: {
    AppTextareaAi,
  },
  props: {
    localResume: {
      type: Object,
      required: true,
    },
    isFormativeAction: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
